"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 아이템·데이터를 영구 삭제하는 파괴적 액션 버튼.
 */
let DeleteButton = class DeleteButton extends (0, icon_button_utils_1.iconActionElement)({
    event: 'delete',
    icon: icon_names_1.ICON_NAMES.DELETE,
    ariaLabel: '삭제',
}) {
    // 파괴적 행동이라 확인을 거친 뒤에만 알린다.
    handleActionClick() {
        if (!window.confirm('정말 삭제하시겠어요?'))
            return;
        super.handleActionClick();
    }
};
DeleteButton.styles = [
    shared_styles_1.resetStyles,
    icon_button_styles_1.iconButtonStyles,
    (0, lit_1.css) `
      :host {
        ${(0, icon_button_styles_1.iconButtonVariantSkin)('danger')}
      }
    `,
];
DeleteButton = __decorate([
    (0, decorators_js_1.customElement)('mm-delete-button')
], DeleteButton);
exports.DeleteButton = DeleteButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVsZXRlLWJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImRlbGV0ZS1idXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXlCO0FBQ3pCLHFEQUFpRDtBQUVqRCxvRUFBZ0U7QUFDaEUsMkZBRzJEO0FBQzNELHlGQUFxRjtBQUNyRiwrREFBeUQ7QUFFekQ7O0dBRUc7QUFFSSxJQUFNLFlBQVksR0FBbEIsTUFBTSxZQUFhLFNBQVEsSUFBQSxxQ0FBaUIsRUFBQztJQUNsRCxLQUFLLEVBQUUsUUFBUTtJQUNmLElBQUksRUFBRSx1QkFBVSxDQUFDLE1BQU07SUFDdkIsU0FBUyxFQUFFLElBQUk7Q0FDaEIsQ0FBQztJQVVBLDJCQUEyQjtJQUNsQixpQkFBaUI7UUFDeEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDO1lBQUUsT0FBTTtRQUUxQyxLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtJQUMzQixDQUFDOztBQWRNLG1CQUFNLEdBQUc7SUFDZCwyQkFBVztJQUNYLHFDQUFnQjtJQUNoQixJQUFBLFNBQUcsRUFBQTs7VUFFRyxJQUFBLDBDQUFxQixFQUFDLFFBQVEsQ0FBQzs7S0FFcEM7Q0FDRixDQUFBO0FBYlUsWUFBWTtJQUR4QixJQUFBLDZCQUFhLEVBQUMsa0JBQWtCLENBQUM7R0FDckIsWUFBWSxDQW9CeEI7QUFwQlksb0NBQVkifQ==